export default "__VITE_ASSET__X1sWHisc__"